export const LANDING_DIRECT_CONVERSION_EXPERIMENT = 'landing_direct_conversion';
export const LANDING_DIRECT_CONVERSION_TREATMENT = 'treatment';
export const isDirectConversionTreatmentCheckout = (experiment, variant) => experiment?.trim() === LANDING_DIRECT_CONVERSION_EXPERIMENT &&
    variant?.trim() === LANDING_DIRECT_CONVERSION_TREATMENT;
//# sourceMappingURL=directConversionTreatment.js.map